const AllBenefitAndDeduction = () =>
  import("./views/AllBenefitAndDeduction.vue");
const BenefitAndDeductionForm = () =>
  import("./views/BenefitAndDeductionForm.vue");

const BenefitAndDeductionViewDetails = () =>
  import("./views/BenefitAndDeductionViewDetails.vue");
const BenefitAndDeductionSettings = () =>
  import("./views/BenefitAndDeductionSettings.vue");
const BenefitAndDeductionType = () =>
  import("./views/BenefitAndDeductionType.vue");
const BenefitAndDeductionTypeForm = () =>
  import("./views/BenefitAndDeductionTypeForm.vue");

const BenefitAndDeductionApproval = () =>
  import("./views/BenefitAndDeductionApproval.vue");
const BenefitAndDeductionApprovalView = () =>
  import("./views/BenefitAndDeductionViewDetails.vue");

const AllApprovers = () =>
  import("@/components/general/approvals/AllApprovers.vue");
const AssignEmployeesAsApprovers = () =>
  import("@/components/general/approvals/AssignEmployeeToApprover.vue");
const ViewApprovers = () =>
  import("@/components/general/approvals/ViewApprovers.vue");
const CreateApprover = () =>
  import("@/components/general/approvals/CreateApprovers.vue");
import approverProps from "@/components/general/approvals/ApproverProps.js";
const { benefitAndDeduction } = approverProps;
export default [
  {
    path: "view-all",
    component: AllBenefitAndDeduction,
  },
  {
    path: "create",
    component: BenefitAndDeductionForm,
  },
  {
    name: "edit-benefit-deduction",
    path: "edit/:id",
    component: BenefitAndDeductionForm,
  },
  {
    path: "view-details/:id",
    component: BenefitAndDeductionViewDetails,
  },
  {
    path: "approval",
    component: BenefitAndDeductionApproval,
  },
  {
    path: "approval/view/:id",
    component: BenefitAndDeductionApprovalView,
  },
  {
    path: "settings",
    component: BenefitAndDeductionSettings,
  },
  {
    path: "settings/benefit-deduction-type/view-all",
    component: BenefitAndDeductionType,
  },
  {
    path: "settings/benefit-deduction-type/create",
    component: BenefitAndDeductionTypeForm,
  },
  {
    path: "settings/benefit-deduction-type/edit/:id",
    component: BenefitAndDeductionTypeForm,
  },
  {
    path: "settings/approvers",
    component: AllApprovers,
    props: benefitAndDeduction,
  },
  {
    path: "settings/approvers/assign/:id",
    component: AssignEmployeesAsApprovers,
    props: benefitAndDeduction,
  },
  {
    path: "settings/approvers/edit/:id",
    component: CreateApprover,
    props: benefitAndDeduction,
  },
  {
    path: "settings/approvers/view/:id",
    component: ViewApprovers,
    props: benefitAndDeduction,
  },
  {
    path: "settings/approvers/create",
    component: CreateApprover,
    props: benefitAndDeduction,
  },
];
